import React, { useEffect, useState } from 'react';
import { AuthContainer, AuthScreen, Footer, LogoHolder } from './style';
import { Form, Input, Label } from 'reactstrap';
import Appinfo from 'containers/Appinfo';
import logo from 'assets/img/logo.png';
import { useHistory } from 'react-router';
import { cache } from 'apolloClient';
import { notify } from 'react-notify-toast';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { Button } from 'components';

export const getSearchParams = (): URLSearchParams => {
    return new URLSearchParams(window.location.search);
};

const Login = () => {
    const params = getSearchParams();
    const token = params.get('token');
    const history = useHistory();

    const [state, setState] = useState({
        code: '',
        twoFaToken: token || '',
    });

    const MUTATION = gql`
        mutation($credentials: AuthInput) {
            authenticate(credentials: $credentials) {
                code
                twoFaToken
                token
                user
            }
        }
    `;

    const [login] = useMutation(MUTATION);

    useEffect(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('network');
        localStorage.removeItem('user');
        localStorage.removeItem('containerId');
    }, []);

    const change = e => {
        const name = e.target.name;
        const value = e.target.value;
        const newState = { ...state, [name]: value };
        setState(newState);
    };

    const onSubmit = async (ev, values) => {
        ev.preventDefault();
        try {
            const { data } = await login({
                variables: {
                    credentials: values,
                },
            });

            await localStorage.setItem('token', data.authenticate?.token);
            await localStorage.setItem('user', JSON.stringify(data.authenticate?.user));
            await localStorage.setItem(
                'network',
                window.localStorage.getItem('network') || Object.keys(data.authenticate?.user?.networks)[0],
            );

            if (data.authenticate.token) {
                cache.writeQuery({
                    query: gql`
                        query Cache {
                            token
                            network
                            user
                        }
                    `,
                    data: {
                        token: data.authenticate.token,
                        network:
                            window.localStorage.getItem('network') ||
                            Object.keys(data.authenticate.user.networks)[0],
                        user: data.authenticate.user,
                    },
                });

                history.push('/containers');
            }
        } catch (e: any) {
            notify.show(e.message, 'error');
        }
    };

    return (
        <>
            <AuthScreen>
                <img src={logo} alt='logo' />
                <AuthContainer>
                    <LogoHolder>
                        <div>
                            <h1>MFA</h1>
                            <p>MFA required in order to login</p>
                        </div>
                    </LogoHolder>
                    <div style={{ padding: '10px 20px 10px', overflow: 'hidden' }}>
                        <p>Enter the code sent to your email or 2FA device</p>
                        <Form onSubmit={e => onSubmit(e, state)}>
                            <Label>MFA Code</Label>
                            <Input defaultValue={state.code} name='code' onChange={change} />
                            <input type='hidden' name='twoFaToken' value={state.twoFaToken} />
                            <Button>Login</Button>
                        </Form>
                    </div>
                </AuthContainer>
            </AuthScreen>

            <Footer>
                <Appinfo />
            </Footer>
        </>
    );
};

export default Login;
